import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import cn from 'classnames'
import {
  InputField,
  SelectField,
  COUNTRIES_OPTS,
} from '../Modals/SupervisionModal'
import { Button } from '../controls'
import { useQuery, useMutation } from '@apollo/client'
import { QUERY, MUTATION } from '../../apollo'
import styles from '../Modals/modal.module.css'
import dStyles from './detail.module.css'

function BillingInfo() {
  const { data } = useQuery(QUERY.USER_INFO)
  const userInfo = data?.userInfo

  const [updateValues] = useMutation(MUTATION.UPDATE_VALUE, {
    onError: (error) => {
      console.log({ error })
      console.log(error.graphQLErrors[0].message)
    },
    // refetchQueries: [{ query: QUERY.USER_INFO }],
  })

  async function onSubmit({ __typename, ...values }) {
    try {
      await updateValues({
        variables: { requestType: 'billingInfo', input: values },
      })
    } catch (err) {
      console.log({ err })
    }
  }
  // const { __typename, ...initialValues } = userInfo
  //   ? userInfo.billingInfo
  //   : { __typename: 'BillingInfo' }
  // console.log({ initialValues })

  const initialValues = userInfo
    ? {
        address: userInfo.billingInfo.address ?? '',
        city: userInfo.billingInfo.city ?? '',
        company: userInfo.billingInfo.company ?? '',
        country: userInfo.billingInfo.country ?? '',
        email: userInfo.billingInfo.email ?? '',
        extraInfo: userInfo.billingInfo.extraInfo ?? '',
        name: userInfo.billingInfo.name ?? '',
        phone: userInfo.billingInfo.phone ?? '',
        vat: userInfo.billingInfo.vat ?? '',
        zip: userInfo.billingInfo.zip ?? '',
      }
    : {}

  return (
    <div className={cn(dStyles.wrapper, dStyles.expanded)}>
      <div className={cn(dStyles.content)}>
        <p className={dStyles.pageTitle}>
          Please complete your billing information for contract and invoices
          download.
        </p>
        {userInfo ? (
          <Formik
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            initialValues={initialValues}
            validateOnChange
            enableReinitialize
          >
            {({
              isSubmitting,
              handleSubmit,
              setFieldValue,
              setFieldTouched,
              dirty,
              values,
              errors,
              initialErrors,
            }) => {
              return (
                <form
                  onSubmit={handleSubmit}
                  className={cn(styles.grid, styles.form)}
                >
                  <InputField
                    name="company"
                    placeholder="Company"
                    type="text"
                  />
                  <InputField
                    name="name"
                    placeholder="Full Name*"
                    type="text"
                  />
                  <InputField
                    name="address"
                    placeholder="Address"
                    type="text"
                  />
                  <InputField name="city" placeholder="City" type="text" />
                  <InputField name="zip" placeholder="Zip Code" type="text" />

                  <SelectField
                    name="country"
                    options={COUNTRIES_OPTS}
                    placeholder="Country*"
                    onChange={(value) => setFieldValue('country', value.label)}
                    onBlur={() => setFieldTouched('country', true)}
                    value={COUNTRIES_OPTS.filter(
                      (c) => c.label === values.country
                    )}
                  />
                  <InputField name="email" placeholder="Email" type="text" />
                  <InputField
                    name="phone"
                    placeholder="Phone Number"
                    type="text"
                  />
                  <InputField name="vat" placeholder="Vat ID" type="text" />
                  <InputField
                    name="extraInfo"
                    placeholder="Extra Info"
                    type="text"
                  />

                  <footer className={styles.formFooter}>
                    <Button
                      className={styles.button}
                      type="submit"
                      disabled={isSubmitting || !dirty}
                    >
                      {!dirty ? 'Updated' : 'Save'}
                    </Button>
                  </footer>
                </form>
              )
            }}
          </Formik>
        ) : null}
      </div>
    </div>
  )
}

export default BillingInfo

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  country: Yup.string().required('Required'),
})
